/* eslint-disable max-len */
// eslint-disable-next-line object-curly-newline
import React, { useContext, useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { QuestionSetComponent } from 'gw-components-platform-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { DeviceBreakpoint, FlowStepId, Position } from 'wmic-portals-utils-js';
// eslint-disable-next-line import/no-unresolved
import config from 'app-config';

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './QualificationPage.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

const LOB_PATH = {
    PersonalAuto: 'lobData.personalAuto.preQualQuestionSets.children[0].value',
    Homeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    HOPHomeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    BusinessOwners: 'lobData.businessOwners.preQualQuestionSets.children[0].value',
    BusinessAuto: 'lobData.businessOwners.preQualQuestionSets.children[0].value',
    PersonalUmbrella: 'lobData.personalUmbrella.preQualQuestionSets.children[0].value'
};

function QualificationPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const {
        registerInitialComponentValidation,
        isComponentValid,
        initialValidation,
        onValidate
    } = useValidation('QualificationPage');
    const [showErrors, setShowErrors] = useState(false);
    const lobCode = _.get(submissionVM.value, 'baseData.productCode');

    const onNext = useCallback(async () => {
        if (isComponentValid) {
            _.unset(submissionVM.value, 'bindData');
            submissionVM.value.flowStepId_WMIC = FlowStepId.PRE_QUALIFICATION;

            submissionVM.value = await LoadSaveService.updateDraftSubmission(
                submissionVM.value,
                authHeader
            );

            return submissionVM;
        }
        setShowErrors(true);
        return false;
    }, [submissionVM, LoadSaveService, authHeader, isComponentValid]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === DeviceBreakpoint.DESKTOP ? Position.LEFT : Position.TOP
        },
        questionSets: {
            path: LOB_PATH[lobCode],
            showErrors: showErrors
        }
    };

    const resolvers = {
        resolveComponentMap: { questionset: QuestionSetComponent },
        resolveCallbackMap: {
            onValidate: onValidate
        }
    };

    const shouldSkipBopPage = useCallback(() => {
        const preQualQuestionSets = _.get(
            submissionVM,
            LOB_PATH[lobCode].replace(/\.children\[\d\]/, '')
        );
        if (!_.isEmpty(preQualQuestionSets)) {
            const answerValues = _.values(preQualQuestionSets[0].answers);
            return answerValues.some((value) => value !== null);
        }
        return false;
    }, [lobCode, submissionVM]);

    const hasLicenseNumberForPADriver = useCallback(() => {
        const licenseNumber = _.get(
            submissionVM,
            'lobData.personalAuto.coverables.drivers.value[0].licenseNumber'
        );

        if (config.persona === 'producer' || config.persona === 'csr') {
            return !_.isEmpty(licenseNumber);
        }
        return true;
    }, [submissionVM]);

    useEffect(() => {
        if (lobCode === 'PersonalAuto') {
            registerInitialComponentValidation(hasLicenseNumberForPADriver);
        } else if (lobCode === 'BusinessOwners') {
            registerInitialComponentValidation(shouldSkipBopPage);
        }
        // execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <WizardPage onNext={onNext} skipWhen={initialValidation} disableNext={!isComponentValid} showMandatoryInfo>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                showErrors={showErrors}
            />
        </WizardPage>
    );
}

QualificationPage.propTypes = wizardProps;
export default QualificationPage;
